import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string): string {
    const [hours, minutes] = value.split(':');
    const time = new Date(2000, 0, 1, Number(hours), Number(minutes));

    return format(time, 'h:mmaaa');
  }
}
